import React, { ReactElement, useState } from 'react'
import { Button } from '@mui/material'
import { pdf } from '@react-pdf/renderer'

import { downloadFile } from 'src/v3/utilities/filesystem'
import { useNotifications } from 'src/v3/hooks/use-notifications'
import {
  fetchCourseFloridaApplication,
  fetchEventFloridaApplication,
} from 'src/v3/content-pipeline/accreditation/utils/florida-application-api'
import FloridaApplicationPdf from './florida-application-pdf'

type Props = {
  kind: 'course' | 'event'
  offeringID?: string
}

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export default function GenerateFloridaApplicationButton({
  kind,
  offeringID,
}: Props): ReactElement {
  let { showError, NotificationComponent } = useNotifications()
  let [isGenerating, setIsGenerating] = useState(false)

  let handleGenerate = async () => {
    if (!offeringID) return
    setIsGenerating(true)
    try {
      let packet =
        kind === 'course'
          ? await fetchCourseFloridaApplication(offeringID)
          : await fetchEventFloridaApplication(offeringID)
      let blob = await pdf(<FloridaApplicationPdf packet={packet} />).toBlob()
      downloadFile(
        blob,
        `${slugify(packet.displayTitle)}-florida-application.pdf`,
      )
    } catch {
      showError(
        'Failed to generate the Florida application PDF. Please try again.',
      )
    } finally {
      setIsGenerating(false)
    }
  }

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleGenerate}
        loading={isGenerating}
        disabled={!offeringID || isGenerating}
      >
        Generate Florida Application
      </Button>
      {NotificationComponent}
    </>
  )
}
